import React from "react";
import {Route, Routes} from "react-router-dom";
import MenuView from "./features/navigation/MenuView";
import {mainMenu} from "./features/navigation/menu";
import People from "./features/people/People";
import Operations from "./features/operation/Operations";
import Machines from "./features/machines/Machines";

import {useSelector} from "react-redux";
import {RootState} from "./store";
import {Role} from "./session_state";
import {Box} from "@mui/material";
import Interruptions from "./features/interruption/Interruptions";
import Product from "./features/products/Product";
import Partner from "./features/partners/Partner";
import RegRouters from "./features/registration/RegRouters";
import AllOpenRegistrations from "./features/registration/AllOpenRegistrations";
import OperationRegistrations from "./features/registration/OperationRegistrations";
import Users from "./features/users/Users";
import WorkOrders from "./features/workOrders/WorkOrders";
import AnalyticsRoutes from "./features/analytics/AnalyticsRoutes";
import Sync from "./features/sync/Sync";
import {UnregisteredListController} from "./features/people/UnregisteredWorkers";
import RegCreate from "./features/registration/RegCreate";

export default function () {
    const myRoles = useSelector<RootState, Array<Role>|null>((state) => state.sessionState.user?.userRoles?.roles || [])
    return <Routes>

        <Route index path={"/menu/:id/*"} element={<Box mt={1}>
            <MenuView myRoles={myRoles || []} pages={[mainMenu]}/>
        </Box>}/>
        <Route path={"/reg/*"} element={<RegRouters/>}/>
        <Route path={"/regs/all"} element={<AllOpenRegistrations/>}/>
        <Route path={"/regs/unregistered"} element={<UnregisteredListController/>}/>
        <Route path={"/regs/oper/*"} element={<OperationRegistrations/>}/>
        <Route path={"/products/*"} element={<Product/>}/>
        <Route path={"/person/*"} element={<People/>}/>
        <Route path={"/machine/*"} element={<Machines/>}/>
        <Route path={"/partners/*"} element={<Partner/>}/>
        <Route path={"/users/*"} element={<Users/>}/>
        <Route path={"/workorder/*"} element={<WorkOrders/>}/>
        <Route path={"/operation/*"} element={<Operations/>}/>
        <Route path={"/intr/*"} element={<Interruptions/>}/>
        <Route path={"/analytics/*"} element={<AnalyticsRoutes/>}/>
        <Route path={"/sync"} element={<Sync/>}/>
    </Routes>
        ;

}



